// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/acp/v1/acp.proto" (package "agency.acp.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../google/protobuf/struct";
// ── Per-type request payloads ─────────────────────────────────────────────────

/**
 * @generated from protobuf message agency.acp.v1.AcpPermissionRequest
 */
export interface AcpPermissionRequest {
    /**
     * tool_call is the pending tool call requiring user approval.
     * Forwarded verbatim as JSON to the ACP client.
     *
     * @generated from protobuf field: google.protobuf.Struct tool_call = 1
     */
    toolCall?: Struct;
    /**
     * options are the permission choices to present to the user.
     *
     * @generated from protobuf field: repeated google.protobuf.Struct options = 2
     */
    options: Struct[];
}
/**
 * @generated from protobuf message agency.acp.v1.AcpFsReadRequest
 */
export interface AcpFsReadRequest {
    /**
     * @generated from protobuf field: string path = 1
     */
    path: string;
    /**
     * line is the 1-based start line (optional; 0 = read from beginning).
     *
     * @generated from protobuf field: int32 line = 2
     */
    line: number;
    /**
     * limit is the maximum number of lines to read (optional; 0 = no limit).
     *
     * @generated from protobuf field: int32 limit = 3
     */
    limit: number;
}
/**
 * @generated from protobuf message agency.acp.v1.AcpFsWriteRequest
 */
export interface AcpFsWriteRequest {
    /**
     * @generated from protobuf field: string path = 1
     */
    path: string;
    /**
     * @generated from protobuf field: string content = 2
     */
    content: string;
}
/**
 * @generated from protobuf message agency.acp.v1.AcpTerminalCreateRequest
 */
export interface AcpTerminalCreateRequest {
    /**
     * @generated from protobuf field: string command = 1
     */
    command: string;
    /**
     * @generated from protobuf field: repeated string args = 2
     */
    args: string[];
    /**
     * @generated from protobuf field: string cwd = 3
     */
    cwd: string;
    /**
     * env carries optional environment variable overrides.
     *
     * @generated from protobuf field: repeated agency.acp.v1.AcpEnvVar env = 4
     */
    env: AcpEnvVar[];
    /**
     * output_byte_limit caps retained terminal output (0 = server default).
     *
     * @generated from protobuf field: int64 output_byte_limit = 5
     */
    outputByteLimit: bigint;
}
/**
 * @generated from protobuf message agency.acp.v1.AcpEnvVar
 */
export interface AcpEnvVar {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string value = 2
     */
    value: string;
}
/**
 * @generated from protobuf message agency.acp.v1.AcpTerminalRef
 */
export interface AcpTerminalRef {
    /**
     * @generated from protobuf field: string terminal_id = 1
     */
    terminalId: string;
}
/**
 * @generated from protobuf message agency.acp.v1.AcpCustomToolRequest
 */
export interface AcpCustomToolRequest {
    /**
     * @generated from protobuf field: string tool_name = 1
     */
    toolName: string;
    /**
     * arguments are genuinely open — tool-specific JSON object.
     *
     * @generated from protobuf field: google.protobuf.Struct arguments = 2
     */
    arguments?: Struct;
}
// ── Per-type response payloads ────────────────────────────────────────────────

/**
 * @generated from protobuf message agency.acp.v1.AcpPermissionResponse
 */
export interface AcpPermissionResponse {
    /**
     * @generated from protobuf oneof: outcome
     */
    outcome: {
        oneofKind: "selected";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpPermissionSelected selected = 1
         */
        selected: AcpPermissionSelected;
    } | {
        oneofKind: "cancelled";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpPermissionCancelled cancelled = 2
         */
        cancelled: AcpPermissionCancelled;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message agency.acp.v1.AcpPermissionSelected
 */
export interface AcpPermissionSelected {
    /**
     * @generated from protobuf field: string option_id = 1
     */
    optionId: string;
}
/**
 * @generated from protobuf message agency.acp.v1.AcpPermissionCancelled
 */
export interface AcpPermissionCancelled {
}
/**
 * @generated from protobuf message agency.acp.v1.AcpFsReadResponse
 */
export interface AcpFsReadResponse {
    /**
     * @generated from protobuf field: string content = 1
     */
    content: string;
}
/**
 * @generated from protobuf message agency.acp.v1.AcpFsWriteResponse
 */
export interface AcpFsWriteResponse {
}
/**
 * @generated from protobuf message agency.acp.v1.AcpTerminalCreateResponse
 */
export interface AcpTerminalCreateResponse {
    /**
     * @generated from protobuf field: string terminal_id = 1
     */
    terminalId: string;
}
/**
 * @generated from protobuf message agency.acp.v1.AcpTerminalOutputResponse
 */
export interface AcpTerminalOutputResponse {
    /**
     * @generated from protobuf field: string output = 1
     */
    output: string;
    /**
     * @generated from protobuf field: bool truncated = 2
     */
    truncated: boolean;
    /**
     * exit_status is set when the process has already exited.
     *
     * @generated from protobuf field: agency.acp.v1.AcpExitStatus exit_status = 3
     */
    exitStatus?: AcpExitStatus;
}
/**
 * @generated from protobuf message agency.acp.v1.AcpTerminalExitResponse
 */
export interface AcpTerminalExitResponse {
    /**
     * @generated from protobuf field: agency.acp.v1.AcpExitStatus exit_status = 1
     */
    exitStatus?: AcpExitStatus;
}
/**
 * @generated from protobuf message agency.acp.v1.AcpTerminalKillResponse
 */
export interface AcpTerminalKillResponse {
}
/**
 * @generated from protobuf message agency.acp.v1.AcpTerminalReleaseResponse
 */
export interface AcpTerminalReleaseResponse {
}
/**
 * @generated from protobuf message agency.acp.v1.AcpExitStatus
 */
export interface AcpExitStatus {
    /**
     * exit_code is set when the process exited normally.
     *
     * @generated from protobuf field: int32 exit_code = 1
     */
    exitCode: number;
    /**
     * signal is set when the process was killed by a signal (e.g. "SIGKILL").
     *
     * @generated from protobuf field: string signal = 2
     */
    signal: string;
}
/**
 * @generated from protobuf message agency.acp.v1.AcpCustomToolResponse
 */
export interface AcpCustomToolResponse {
    /**
     * result is the tool's return value — structure is tool-defined.
     *
     * @generated from protobuf field: google.protobuf.Struct result = 1
     */
    result?: Struct;
    /**
     * @generated from protobuf field: bool is_error = 2
     */
    isError: boolean;
    /**
     * @generated from protobuf field: string error_message = 3
     */
    errorMessage: string;
}
// ── Wire messages ─────────────────────────────────────────────────────────────

/**
 * AcpRequest is published by the harness to acp-requests.<tenant>.<workspace>.<session>
 * using NATS core req/reply (msg.Reply carries the response inbox).
 * The edge layer deserializes, forwards the typed request to the ACP client via GRIP,
 * stores correlation_id → msg.Reply, and publishes AcpResponse to msg.Reply on receipt.
 *
 * @generated from protobuf message agency.acp.v1.AcpRequest
 */
export interface AcpRequest {
    /**
     * correlation_id uniquely identifies this round-trip within the session.
     *
     * @generated from protobuf field: string correlation_id = 1
     */
    correlationId: string;
    /**
     * session_id is the ACP session this request belongs to (== thread_id).
     *
     * @generated from protobuf field: string session_id = 2
     */
    sessionId: string;
    /**
     * request carries the typed payload — exactly one arm must be set.
     *
     * @generated from protobuf oneof: request
     */
    request: {
        oneofKind: "permission";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpPermissionRequest permission = 3
         */
        permission: AcpPermissionRequest;
    } | {
        oneofKind: "fsRead";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpFsReadRequest fs_read = 4
         */
        fsRead: AcpFsReadRequest;
    } | {
        oneofKind: "fsWrite";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpFsWriteRequest fs_write = 5
         */
        fsWrite: AcpFsWriteRequest;
    } | {
        oneofKind: "terminalCreate";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpTerminalCreateRequest terminal_create = 6
         */
        terminalCreate: AcpTerminalCreateRequest;
    } | {
        oneofKind: "terminalOutput";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpTerminalRef terminal_output = 7
         */
        terminalOutput: AcpTerminalRef;
    } | {
        oneofKind: "terminalExit";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpTerminalRef terminal_exit = 8
         */
        terminalExit: AcpTerminalRef;
    } | {
        oneofKind: "terminalKill";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpTerminalRef terminal_kill = 9
         */
        terminalKill: AcpTerminalRef;
    } | {
        oneofKind: "terminalRelease";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpTerminalRef terminal_release = 10
         */
        terminalRelease: AcpTerminalRef;
    } | {
        oneofKind: "customTool";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpCustomToolRequest custom_tool = 11
         */
        customTool: AcpCustomToolRequest;
    } | {
        oneofKind: undefined;
    };
}
/**
 * AcpResponse is published by the edge layer to the NATS msg.Reply inbox
 * after the ACP client has resolved the round-trip request.
 *
 * @generated from protobuf message agency.acp.v1.AcpResponse
 */
export interface AcpResponse {
    /**
     * correlation_id matches the originating AcpRequest.
     *
     * @generated from protobuf field: string correlation_id = 1
     */
    correlationId: string;
    /**
     * session_id matches the originating AcpRequest.
     *
     * @generated from protobuf field: string session_id = 2
     */
    sessionId: string;
    /**
     * response carries the typed result — exactly one arm must be set.
     *
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "permission";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpPermissionResponse permission = 3
         */
        permission: AcpPermissionResponse;
    } | {
        oneofKind: "fsRead";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpFsReadResponse fs_read = 4
         */
        fsRead: AcpFsReadResponse;
    } | {
        oneofKind: "fsWrite";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpFsWriteResponse fs_write = 5
         */
        fsWrite: AcpFsWriteResponse;
    } | {
        oneofKind: "terminalCreate";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpTerminalCreateResponse terminal_create = 6
         */
        terminalCreate: AcpTerminalCreateResponse;
    } | {
        oneofKind: "terminalOutput";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpTerminalOutputResponse terminal_output = 7
         */
        terminalOutput: AcpTerminalOutputResponse;
    } | {
        oneofKind: "terminalExit";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpTerminalExitResponse terminal_exit = 8
         */
        terminalExit: AcpTerminalExitResponse;
    } | {
        oneofKind: "terminalKill";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpTerminalKillResponse terminal_kill = 9
         */
        terminalKill: AcpTerminalKillResponse;
    } | {
        oneofKind: "terminalRelease";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpTerminalReleaseResponse terminal_release = 10
         */
        terminalRelease: AcpTerminalReleaseResponse;
    } | {
        oneofKind: "customTool";
        /**
         * @generated from protobuf field: agency.acp.v1.AcpCustomToolResponse custom_tool = 11
         */
        customTool: AcpCustomToolResponse;
    } | {
        oneofKind: undefined;
    };
}
/**
 * AcpRequestType discriminates the round-trip request kind.
 * Published by the harness to acp-requests.<tenant>.<workspace>.<session> (NATS req/reply).
 * The edge layer forwards to the ACP client via GRIP and routes the response back.
 *
 * @generated from protobuf enum agency.acp.v1.AcpRequestType
 */
export enum AcpRequestType {
    /**
     * ACP_REQUEST_TYPE_UNSPECIFIED is invalid.
     *
     * @generated from protobuf enum value: ACP_REQUEST_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * ACP_REQUEST_TYPE_PERMISSION — session/request_permission round-trip.
     *
     * @generated from protobuf enum value: ACP_REQUEST_TYPE_PERMISSION = 1;
     */
    PERMISSION = 1,
    /**
     * ACP_REQUEST_TYPE_FS_READ — fs/read_text_file round-trip.
     *
     * @generated from protobuf enum value: ACP_REQUEST_TYPE_FS_READ = 2;
     */
    FS_READ = 2,
    /**
     * ACP_REQUEST_TYPE_FS_WRITE — fs/write_text_file round-trip.
     *
     * @generated from protobuf enum value: ACP_REQUEST_TYPE_FS_WRITE = 3;
     */
    FS_WRITE = 3,
    /**
     * ACP_REQUEST_TYPE_TERMINAL_CREATE — terminal/create round-trip.
     *
     * @generated from protobuf enum value: ACP_REQUEST_TYPE_TERMINAL_CREATE = 4;
     */
    TERMINAL_CREATE = 4,
    /**
     * ACP_REQUEST_TYPE_TERMINAL_OUTPUT — terminal/output round-trip.
     *
     * @generated from protobuf enum value: ACP_REQUEST_TYPE_TERMINAL_OUTPUT = 5;
     */
    TERMINAL_OUTPUT = 5,
    /**
     * ACP_REQUEST_TYPE_TERMINAL_EXIT — terminal/wait_for_exit round-trip.
     *
     * @generated from protobuf enum value: ACP_REQUEST_TYPE_TERMINAL_EXIT = 6;
     */
    TERMINAL_EXIT = 6,
    /**
     * ACP_REQUEST_TYPE_TERMINAL_KILL — terminal/kill round-trip.
     *
     * @generated from protobuf enum value: ACP_REQUEST_TYPE_TERMINAL_KILL = 7;
     */
    TERMINAL_KILL = 7,
    /**
     * ACP_REQUEST_TYPE_TERMINAL_RELEASE — terminal/release round-trip.
     *
     * @generated from protobuf enum value: ACP_REQUEST_TYPE_TERMINAL_RELEASE = 8;
     */
    TERMINAL_RELEASE = 8,
    /**
     * ACP_REQUEST_TYPE_CUSTOM_TOOL — generic custom tool call.
     * Handles any tool not mapped to a built-in ACP capability.
     *
     * @generated from protobuf enum value: ACP_REQUEST_TYPE_CUSTOM_TOOL = 9;
     */
    CUSTOM_TOOL = 9
}
// @generated message type with reflection information, may provide speed optimized methods
class AcpPermissionRequest$Type extends MessageType<AcpPermissionRequest> {
    constructor() {
        super("agency.acp.v1.AcpPermissionRequest", [
            { no: 1, name: "tool_call", kind: "message", T: () => Struct, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<AcpPermissionRequest>): AcpPermissionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.options = [];
        if (value !== undefined)
            reflectionMergePartial<AcpPermissionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpPermissionRequest): AcpPermissionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Struct tool_call */ 1:
                    message.toolCall = Struct.internalBinaryRead(reader, reader.uint32(), options, message.toolCall);
                    break;
                case /* repeated google.protobuf.Struct options */ 2:
                    message.options.push(Struct.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpPermissionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Struct tool_call = 1; */
        if (message.toolCall)
            Struct.internalBinaryWrite(message.toolCall, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Struct options = 2; */
        for (let i = 0; i < message.options.length; i++)
            Struct.internalBinaryWrite(message.options[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpPermissionRequest
 */
export const AcpPermissionRequest = new AcpPermissionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpFsReadRequest$Type extends MessageType<AcpFsReadRequest> {
    constructor() {
        super("agency.acp.v1.AcpFsReadRequest", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 2, name: "line", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 3, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<AcpFsReadRequest>): AcpFsReadRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.path = "";
        message.line = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial<AcpFsReadRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpFsReadRequest): AcpFsReadRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string path */ 1:
                    message.path = reader.string();
                    break;
                case /* int32 line */ 2:
                    message.line = reader.int32();
                    break;
                case /* int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpFsReadRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string path = 1; */
        if (message.path !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.path);
        /* int32 line = 2; */
        if (message.line !== 0)
            writer.tag(2, WireType.Varint).int32(message.line);
        /* int32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpFsReadRequest
 */
export const AcpFsReadRequest = new AcpFsReadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpFsWriteRequest$Type extends MessageType<AcpFsWriteRequest> {
    constructor() {
        super("agency.acp.v1.AcpFsWriteRequest", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AcpFsWriteRequest>): AcpFsWriteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.path = "";
        message.content = "";
        if (value !== undefined)
            reflectionMergePartial<AcpFsWriteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpFsWriteRequest): AcpFsWriteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string path */ 1:
                    message.path = reader.string();
                    break;
                case /* string content */ 2:
                    message.content = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpFsWriteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string path = 1; */
        if (message.path !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.path);
        /* string content = 2; */
        if (message.content !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.content);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpFsWriteRequest
 */
export const AcpFsWriteRequest = new AcpFsWriteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpTerminalCreateRequest$Type extends MessageType<AcpTerminalCreateRequest> {
    constructor() {
        super("agency.acp.v1.AcpTerminalCreateRequest", [
            { no: 1, name: "command", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 2, name: "args", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "cwd", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 4, name: "env", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AcpEnvVar },
            { no: 5, name: "output_byte_limit", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<AcpTerminalCreateRequest>): AcpTerminalCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.command = "";
        message.args = [];
        message.cwd = "";
        message.env = [];
        message.outputByteLimit = 0n;
        if (value !== undefined)
            reflectionMergePartial<AcpTerminalCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpTerminalCreateRequest): AcpTerminalCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string command */ 1:
                    message.command = reader.string();
                    break;
                case /* repeated string args */ 2:
                    message.args.push(reader.string());
                    break;
                case /* string cwd */ 3:
                    message.cwd = reader.string();
                    break;
                case /* repeated agency.acp.v1.AcpEnvVar env */ 4:
                    message.env.push(AcpEnvVar.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 output_byte_limit */ 5:
                    message.outputByteLimit = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpTerminalCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string command = 1; */
        if (message.command !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.command);
        /* repeated string args = 2; */
        for (let i = 0; i < message.args.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.args[i]);
        /* string cwd = 3; */
        if (message.cwd !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.cwd);
        /* repeated agency.acp.v1.AcpEnvVar env = 4; */
        for (let i = 0; i < message.env.length; i++)
            AcpEnvVar.internalBinaryWrite(message.env[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int64 output_byte_limit = 5; */
        if (message.outputByteLimit !== 0n)
            writer.tag(5, WireType.Varint).int64(message.outputByteLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpTerminalCreateRequest
 */
export const AcpTerminalCreateRequest = new AcpTerminalCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpEnvVar$Type extends MessageType<AcpEnvVar> {
    constructor() {
        super("agency.acp.v1.AcpEnvVar", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "65536" } } } }
        ]);
    }
    create(value?: PartialMessage<AcpEnvVar>): AcpEnvVar {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<AcpEnvVar>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpEnvVar): AcpEnvVar {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpEnvVar, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpEnvVar
 */
export const AcpEnvVar = new AcpEnvVar$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpTerminalRef$Type extends MessageType<AcpTerminalRef> {
    constructor() {
        super("agency.acp.v1.AcpTerminalRef", [
            { no: 1, name: "terminal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } }
        ]);
    }
    create(value?: PartialMessage<AcpTerminalRef>): AcpTerminalRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.terminalId = "";
        if (value !== undefined)
            reflectionMergePartial<AcpTerminalRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpTerminalRef): AcpTerminalRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string terminal_id */ 1:
                    message.terminalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpTerminalRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string terminal_id = 1; */
        if (message.terminalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.terminalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpTerminalRef
 */
export const AcpTerminalRef = new AcpTerminalRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpCustomToolRequest$Type extends MessageType<AcpCustomToolRequest> {
    constructor() {
        super("agency.acp.v1.AcpCustomToolRequest", [
            { no: 1, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "arguments", kind: "message", T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<AcpCustomToolRequest>): AcpCustomToolRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toolName = "";
        if (value !== undefined)
            reflectionMergePartial<AcpCustomToolRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpCustomToolRequest): AcpCustomToolRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tool_name */ 1:
                    message.toolName = reader.string();
                    break;
                case /* google.protobuf.Struct arguments */ 2:
                    message.arguments = Struct.internalBinaryRead(reader, reader.uint32(), options, message.arguments);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpCustomToolRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tool_name = 1; */
        if (message.toolName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.toolName);
        /* google.protobuf.Struct arguments = 2; */
        if (message.arguments)
            Struct.internalBinaryWrite(message.arguments, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpCustomToolRequest
 */
export const AcpCustomToolRequest = new AcpCustomToolRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpPermissionResponse$Type extends MessageType<AcpPermissionResponse> {
    constructor() {
        super("agency.acp.v1.AcpPermissionResponse", [
            { no: 1, name: "selected", kind: "message", oneof: "outcome", T: () => AcpPermissionSelected },
            { no: 2, name: "cancelled", kind: "message", oneof: "outcome", T: () => AcpPermissionCancelled }
        ]);
    }
    create(value?: PartialMessage<AcpPermissionResponse>): AcpPermissionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.outcome = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AcpPermissionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpPermissionResponse): AcpPermissionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.acp.v1.AcpPermissionSelected selected */ 1:
                    message.outcome = {
                        oneofKind: "selected",
                        selected: AcpPermissionSelected.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).selected)
                    };
                    break;
                case /* agency.acp.v1.AcpPermissionCancelled cancelled */ 2:
                    message.outcome = {
                        oneofKind: "cancelled",
                        cancelled: AcpPermissionCancelled.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).cancelled)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpPermissionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.acp.v1.AcpPermissionSelected selected = 1; */
        if (message.outcome.oneofKind === "selected")
            AcpPermissionSelected.internalBinaryWrite(message.outcome.selected, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpPermissionCancelled cancelled = 2; */
        if (message.outcome.oneofKind === "cancelled")
            AcpPermissionCancelled.internalBinaryWrite(message.outcome.cancelled, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpPermissionResponse
 */
export const AcpPermissionResponse = new AcpPermissionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpPermissionSelected$Type extends MessageType<AcpPermissionSelected> {
    constructor() {
        super("agency.acp.v1.AcpPermissionSelected", [
            { no: 1, name: "option_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<AcpPermissionSelected>): AcpPermissionSelected {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.optionId = "";
        if (value !== undefined)
            reflectionMergePartial<AcpPermissionSelected>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpPermissionSelected): AcpPermissionSelected {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string option_id */ 1:
                    message.optionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpPermissionSelected, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string option_id = 1; */
        if (message.optionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.optionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpPermissionSelected
 */
export const AcpPermissionSelected = new AcpPermissionSelected$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpPermissionCancelled$Type extends MessageType<AcpPermissionCancelled> {
    constructor() {
        super("agency.acp.v1.AcpPermissionCancelled", []);
    }
    create(value?: PartialMessage<AcpPermissionCancelled>): AcpPermissionCancelled {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AcpPermissionCancelled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpPermissionCancelled): AcpPermissionCancelled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpPermissionCancelled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpPermissionCancelled
 */
export const AcpPermissionCancelled = new AcpPermissionCancelled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpFsReadResponse$Type extends MessageType<AcpFsReadResponse> {
    constructor() {
        super("agency.acp.v1.AcpFsReadResponse", [
            { no: 1, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AcpFsReadResponse>): AcpFsReadResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.content = "";
        if (value !== undefined)
            reflectionMergePartial<AcpFsReadResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpFsReadResponse): AcpFsReadResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string content */ 1:
                    message.content = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpFsReadResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string content = 1; */
        if (message.content !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.content);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpFsReadResponse
 */
export const AcpFsReadResponse = new AcpFsReadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpFsWriteResponse$Type extends MessageType<AcpFsWriteResponse> {
    constructor() {
        super("agency.acp.v1.AcpFsWriteResponse", []);
    }
    create(value?: PartialMessage<AcpFsWriteResponse>): AcpFsWriteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AcpFsWriteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpFsWriteResponse): AcpFsWriteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpFsWriteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpFsWriteResponse
 */
export const AcpFsWriteResponse = new AcpFsWriteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpTerminalCreateResponse$Type extends MessageType<AcpTerminalCreateResponse> {
    constructor() {
        super("agency.acp.v1.AcpTerminalCreateResponse", [
            { no: 1, name: "terminal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } }
        ]);
    }
    create(value?: PartialMessage<AcpTerminalCreateResponse>): AcpTerminalCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.terminalId = "";
        if (value !== undefined)
            reflectionMergePartial<AcpTerminalCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpTerminalCreateResponse): AcpTerminalCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string terminal_id */ 1:
                    message.terminalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpTerminalCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string terminal_id = 1; */
        if (message.terminalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.terminalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpTerminalCreateResponse
 */
export const AcpTerminalCreateResponse = new AcpTerminalCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpTerminalOutputResponse$Type extends MessageType<AcpTerminalOutputResponse> {
    constructor() {
        super("agency.acp.v1.AcpTerminalOutputResponse", [
            { no: 1, name: "output", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "truncated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "exit_status", kind: "message", T: () => AcpExitStatus }
        ]);
    }
    create(value?: PartialMessage<AcpTerminalOutputResponse>): AcpTerminalOutputResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.output = "";
        message.truncated = false;
        if (value !== undefined)
            reflectionMergePartial<AcpTerminalOutputResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpTerminalOutputResponse): AcpTerminalOutputResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string output */ 1:
                    message.output = reader.string();
                    break;
                case /* bool truncated */ 2:
                    message.truncated = reader.bool();
                    break;
                case /* agency.acp.v1.AcpExitStatus exit_status */ 3:
                    message.exitStatus = AcpExitStatus.internalBinaryRead(reader, reader.uint32(), options, message.exitStatus);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpTerminalOutputResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string output = 1; */
        if (message.output !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.output);
        /* bool truncated = 2; */
        if (message.truncated !== false)
            writer.tag(2, WireType.Varint).bool(message.truncated);
        /* agency.acp.v1.AcpExitStatus exit_status = 3; */
        if (message.exitStatus)
            AcpExitStatus.internalBinaryWrite(message.exitStatus, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpTerminalOutputResponse
 */
export const AcpTerminalOutputResponse = new AcpTerminalOutputResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpTerminalExitResponse$Type extends MessageType<AcpTerminalExitResponse> {
    constructor() {
        super("agency.acp.v1.AcpTerminalExitResponse", [
            { no: 1, name: "exit_status", kind: "message", T: () => AcpExitStatus }
        ]);
    }
    create(value?: PartialMessage<AcpTerminalExitResponse>): AcpTerminalExitResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AcpTerminalExitResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpTerminalExitResponse): AcpTerminalExitResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.acp.v1.AcpExitStatus exit_status */ 1:
                    message.exitStatus = AcpExitStatus.internalBinaryRead(reader, reader.uint32(), options, message.exitStatus);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpTerminalExitResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.acp.v1.AcpExitStatus exit_status = 1; */
        if (message.exitStatus)
            AcpExitStatus.internalBinaryWrite(message.exitStatus, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpTerminalExitResponse
 */
export const AcpTerminalExitResponse = new AcpTerminalExitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpTerminalKillResponse$Type extends MessageType<AcpTerminalKillResponse> {
    constructor() {
        super("agency.acp.v1.AcpTerminalKillResponse", []);
    }
    create(value?: PartialMessage<AcpTerminalKillResponse>): AcpTerminalKillResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AcpTerminalKillResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpTerminalKillResponse): AcpTerminalKillResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpTerminalKillResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpTerminalKillResponse
 */
export const AcpTerminalKillResponse = new AcpTerminalKillResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpTerminalReleaseResponse$Type extends MessageType<AcpTerminalReleaseResponse> {
    constructor() {
        super("agency.acp.v1.AcpTerminalReleaseResponse", []);
    }
    create(value?: PartialMessage<AcpTerminalReleaseResponse>): AcpTerminalReleaseResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AcpTerminalReleaseResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpTerminalReleaseResponse): AcpTerminalReleaseResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpTerminalReleaseResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpTerminalReleaseResponse
 */
export const AcpTerminalReleaseResponse = new AcpTerminalReleaseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpExitStatus$Type extends MessageType<AcpExitStatus> {
    constructor() {
        super("agency.acp.v1.AcpExitStatus", [
            { no: 1, name: "exit_code", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "signal", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64" } } } }
        ]);
    }
    create(value?: PartialMessage<AcpExitStatus>): AcpExitStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exitCode = 0;
        message.signal = "";
        if (value !== undefined)
            reflectionMergePartial<AcpExitStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpExitStatus): AcpExitStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 exit_code */ 1:
                    message.exitCode = reader.int32();
                    break;
                case /* string signal */ 2:
                    message.signal = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpExitStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 exit_code = 1; */
        if (message.exitCode !== 0)
            writer.tag(1, WireType.Varint).int32(message.exitCode);
        /* string signal = 2; */
        if (message.signal !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.signal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpExitStatus
 */
export const AcpExitStatus = new AcpExitStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpCustomToolResponse$Type extends MessageType<AcpCustomToolResponse> {
    constructor() {
        super("agency.acp.v1.AcpCustomToolResponse", [
            { no: 1, name: "result", kind: "message", T: () => Struct },
            { no: 2, name: "is_error", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<AcpCustomToolResponse>): AcpCustomToolResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isError = false;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<AcpCustomToolResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpCustomToolResponse): AcpCustomToolResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Struct result */ 1:
                    message.result = Struct.internalBinaryRead(reader, reader.uint32(), options, message.result);
                    break;
                case /* bool is_error */ 2:
                    message.isError = reader.bool();
                    break;
                case /* string error_message */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpCustomToolResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Struct result = 1; */
        if (message.result)
            Struct.internalBinaryWrite(message.result, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_error = 2; */
        if (message.isError !== false)
            writer.tag(2, WireType.Varint).bool(message.isError);
        /* string error_message = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpCustomToolResponse
 */
export const AcpCustomToolResponse = new AcpCustomToolResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpRequest$Type extends MessageType<AcpRequest> {
    constructor() {
        super("agency.acp.v1.AcpRequest", [
            { no: 1, name: "correlation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "permission", kind: "message", oneof: "request", T: () => AcpPermissionRequest },
            { no: 4, name: "fs_read", kind: "message", oneof: "request", T: () => AcpFsReadRequest },
            { no: 5, name: "fs_write", kind: "message", oneof: "request", T: () => AcpFsWriteRequest },
            { no: 6, name: "terminal_create", kind: "message", oneof: "request", T: () => AcpTerminalCreateRequest },
            { no: 7, name: "terminal_output", kind: "message", oneof: "request", T: () => AcpTerminalRef },
            { no: 8, name: "terminal_exit", kind: "message", oneof: "request", T: () => AcpTerminalRef },
            { no: 9, name: "terminal_kill", kind: "message", oneof: "request", T: () => AcpTerminalRef },
            { no: 10, name: "terminal_release", kind: "message", oneof: "request", T: () => AcpTerminalRef },
            { no: 11, name: "custom_tool", kind: "message", oneof: "request", T: () => AcpCustomToolRequest }
        ]);
    }
    create(value?: PartialMessage<AcpRequest>): AcpRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.correlationId = "";
        message.sessionId = "";
        message.request = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AcpRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpRequest): AcpRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string correlation_id */ 1:
                    message.correlationId = reader.string();
                    break;
                case /* string session_id */ 2:
                    message.sessionId = reader.string();
                    break;
                case /* agency.acp.v1.AcpPermissionRequest permission */ 3:
                    message.request = {
                        oneofKind: "permission",
                        permission: AcpPermissionRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).permission)
                    };
                    break;
                case /* agency.acp.v1.AcpFsReadRequest fs_read */ 4:
                    message.request = {
                        oneofKind: "fsRead",
                        fsRead: AcpFsReadRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).fsRead)
                    };
                    break;
                case /* agency.acp.v1.AcpFsWriteRequest fs_write */ 5:
                    message.request = {
                        oneofKind: "fsWrite",
                        fsWrite: AcpFsWriteRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).fsWrite)
                    };
                    break;
                case /* agency.acp.v1.AcpTerminalCreateRequest terminal_create */ 6:
                    message.request = {
                        oneofKind: "terminalCreate",
                        terminalCreate: AcpTerminalCreateRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).terminalCreate)
                    };
                    break;
                case /* agency.acp.v1.AcpTerminalRef terminal_output */ 7:
                    message.request = {
                        oneofKind: "terminalOutput",
                        terminalOutput: AcpTerminalRef.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).terminalOutput)
                    };
                    break;
                case /* agency.acp.v1.AcpTerminalRef terminal_exit */ 8:
                    message.request = {
                        oneofKind: "terminalExit",
                        terminalExit: AcpTerminalRef.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).terminalExit)
                    };
                    break;
                case /* agency.acp.v1.AcpTerminalRef terminal_kill */ 9:
                    message.request = {
                        oneofKind: "terminalKill",
                        terminalKill: AcpTerminalRef.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).terminalKill)
                    };
                    break;
                case /* agency.acp.v1.AcpTerminalRef terminal_release */ 10:
                    message.request = {
                        oneofKind: "terminalRelease",
                        terminalRelease: AcpTerminalRef.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).terminalRelease)
                    };
                    break;
                case /* agency.acp.v1.AcpCustomToolRequest custom_tool */ 11:
                    message.request = {
                        oneofKind: "customTool",
                        customTool: AcpCustomToolRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).customTool)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string correlation_id = 1; */
        if (message.correlationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.correlationId);
        /* string session_id = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        /* agency.acp.v1.AcpPermissionRequest permission = 3; */
        if (message.request.oneofKind === "permission")
            AcpPermissionRequest.internalBinaryWrite(message.request.permission, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpFsReadRequest fs_read = 4; */
        if (message.request.oneofKind === "fsRead")
            AcpFsReadRequest.internalBinaryWrite(message.request.fsRead, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpFsWriteRequest fs_write = 5; */
        if (message.request.oneofKind === "fsWrite")
            AcpFsWriteRequest.internalBinaryWrite(message.request.fsWrite, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpTerminalCreateRequest terminal_create = 6; */
        if (message.request.oneofKind === "terminalCreate")
            AcpTerminalCreateRequest.internalBinaryWrite(message.request.terminalCreate, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpTerminalRef terminal_output = 7; */
        if (message.request.oneofKind === "terminalOutput")
            AcpTerminalRef.internalBinaryWrite(message.request.terminalOutput, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpTerminalRef terminal_exit = 8; */
        if (message.request.oneofKind === "terminalExit")
            AcpTerminalRef.internalBinaryWrite(message.request.terminalExit, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpTerminalRef terminal_kill = 9; */
        if (message.request.oneofKind === "terminalKill")
            AcpTerminalRef.internalBinaryWrite(message.request.terminalKill, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpTerminalRef terminal_release = 10; */
        if (message.request.oneofKind === "terminalRelease")
            AcpTerminalRef.internalBinaryWrite(message.request.terminalRelease, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpCustomToolRequest custom_tool = 11; */
        if (message.request.oneofKind === "customTool")
            AcpCustomToolRequest.internalBinaryWrite(message.request.customTool, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpRequest
 */
export const AcpRequest = new AcpRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcpResponse$Type extends MessageType<AcpResponse> {
    constructor() {
        super("agency.acp.v1.AcpResponse", [
            { no: 1, name: "correlation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "permission", kind: "message", oneof: "response", T: () => AcpPermissionResponse },
            { no: 4, name: "fs_read", kind: "message", oneof: "response", T: () => AcpFsReadResponse },
            { no: 5, name: "fs_write", kind: "message", oneof: "response", T: () => AcpFsWriteResponse },
            { no: 6, name: "terminal_create", kind: "message", oneof: "response", T: () => AcpTerminalCreateResponse },
            { no: 7, name: "terminal_output", kind: "message", oneof: "response", T: () => AcpTerminalOutputResponse },
            { no: 8, name: "terminal_exit", kind: "message", oneof: "response", T: () => AcpTerminalExitResponse },
            { no: 9, name: "terminal_kill", kind: "message", oneof: "response", T: () => AcpTerminalKillResponse },
            { no: 10, name: "terminal_release", kind: "message", oneof: "response", T: () => AcpTerminalReleaseResponse },
            { no: 11, name: "custom_tool", kind: "message", oneof: "response", T: () => AcpCustomToolResponse }
        ]);
    }
    create(value?: PartialMessage<AcpResponse>): AcpResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.correlationId = "";
        message.sessionId = "";
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AcpResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcpResponse): AcpResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string correlation_id */ 1:
                    message.correlationId = reader.string();
                    break;
                case /* string session_id */ 2:
                    message.sessionId = reader.string();
                    break;
                case /* agency.acp.v1.AcpPermissionResponse permission */ 3:
                    message.response = {
                        oneofKind: "permission",
                        permission: AcpPermissionResponse.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).permission)
                    };
                    break;
                case /* agency.acp.v1.AcpFsReadResponse fs_read */ 4:
                    message.response = {
                        oneofKind: "fsRead",
                        fsRead: AcpFsReadResponse.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).fsRead)
                    };
                    break;
                case /* agency.acp.v1.AcpFsWriteResponse fs_write */ 5:
                    message.response = {
                        oneofKind: "fsWrite",
                        fsWrite: AcpFsWriteResponse.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).fsWrite)
                    };
                    break;
                case /* agency.acp.v1.AcpTerminalCreateResponse terminal_create */ 6:
                    message.response = {
                        oneofKind: "terminalCreate",
                        terminalCreate: AcpTerminalCreateResponse.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).terminalCreate)
                    };
                    break;
                case /* agency.acp.v1.AcpTerminalOutputResponse terminal_output */ 7:
                    message.response = {
                        oneofKind: "terminalOutput",
                        terminalOutput: AcpTerminalOutputResponse.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).terminalOutput)
                    };
                    break;
                case /* agency.acp.v1.AcpTerminalExitResponse terminal_exit */ 8:
                    message.response = {
                        oneofKind: "terminalExit",
                        terminalExit: AcpTerminalExitResponse.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).terminalExit)
                    };
                    break;
                case /* agency.acp.v1.AcpTerminalKillResponse terminal_kill */ 9:
                    message.response = {
                        oneofKind: "terminalKill",
                        terminalKill: AcpTerminalKillResponse.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).terminalKill)
                    };
                    break;
                case /* agency.acp.v1.AcpTerminalReleaseResponse terminal_release */ 10:
                    message.response = {
                        oneofKind: "terminalRelease",
                        terminalRelease: AcpTerminalReleaseResponse.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).terminalRelease)
                    };
                    break;
                case /* agency.acp.v1.AcpCustomToolResponse custom_tool */ 11:
                    message.response = {
                        oneofKind: "customTool",
                        customTool: AcpCustomToolResponse.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).customTool)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcpResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string correlation_id = 1; */
        if (message.correlationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.correlationId);
        /* string session_id = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        /* agency.acp.v1.AcpPermissionResponse permission = 3; */
        if (message.response.oneofKind === "permission")
            AcpPermissionResponse.internalBinaryWrite(message.response.permission, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpFsReadResponse fs_read = 4; */
        if (message.response.oneofKind === "fsRead")
            AcpFsReadResponse.internalBinaryWrite(message.response.fsRead, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpFsWriteResponse fs_write = 5; */
        if (message.response.oneofKind === "fsWrite")
            AcpFsWriteResponse.internalBinaryWrite(message.response.fsWrite, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpTerminalCreateResponse terminal_create = 6; */
        if (message.response.oneofKind === "terminalCreate")
            AcpTerminalCreateResponse.internalBinaryWrite(message.response.terminalCreate, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpTerminalOutputResponse terminal_output = 7; */
        if (message.response.oneofKind === "terminalOutput")
            AcpTerminalOutputResponse.internalBinaryWrite(message.response.terminalOutput, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpTerminalExitResponse terminal_exit = 8; */
        if (message.response.oneofKind === "terminalExit")
            AcpTerminalExitResponse.internalBinaryWrite(message.response.terminalExit, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpTerminalKillResponse terminal_kill = 9; */
        if (message.response.oneofKind === "terminalKill")
            AcpTerminalKillResponse.internalBinaryWrite(message.response.terminalKill, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpTerminalReleaseResponse terminal_release = 10; */
        if (message.response.oneofKind === "terminalRelease")
            AcpTerminalReleaseResponse.internalBinaryWrite(message.response.terminalRelease, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* agency.acp.v1.AcpCustomToolResponse custom_tool = 11; */
        if (message.response.oneofKind === "customTool")
            AcpCustomToolResponse.internalBinaryWrite(message.response.customTool, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.acp.v1.AcpResponse
 */
export const AcpResponse = new AcpResponse$Type();
